import React from 'react';
import {Button, Breadcrumbs, Card, Grid, Layout} from 'components';
import {useNamedSelector} from 'helpers';
import css from 'components/goals/single/select-category.module.scss';

export function SelectCategory() {
  return (
    <main className="bleed has-padding">
      <Layout.Header justified>
        <Breadcrumbs>
          <span>Habits</span>
          <span>New Habit</span>
          <b>Select category</b>
        </Breadcrumbs>
        <Button className={['invisible', 'secondary']}>_</Button>
      </Layout.Header>
      <Grid default>
        { useNamedSelector('activities.categories').map(category =>
          <Card className="selectable" key={category.id} background={category.slug} navLink={'./add/?habitTypeId='+category.id}>
            <div className={css.label}>{ category.name }</div>
          </Card>
        ) }
        <Card className="selectable" background="daily-ritual" navLink="/routines/add-daily-ritual/">
          <div className={css.label}>Daily Ritual</div>
        </Card>
      </Grid>
    </main>
  );
}
